import { render, staticRenderFns } from "./FormRiskContact.vue?vue&type=template&id=411d5fe7&scoped=true&"
import script from "./FormRiskContact.vue?vue&type=script&lang=js&"
export * from "./FormRiskContact.vue?vue&type=script&lang=js&"
import style0 from "./FormRiskContact.vue?vue&type=style&index=0&id=411d5fe7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "411d5fe7",
  null
  
)

export default component.exports